import * as $ from 'jquery';

export const filtering = () => {
    $(document).ready(function() {
        var $channel = window.location.pathname.split('/')[1];
        var data = '';
        $('#articleSearch').submit(function(event) {
            event.preventDefault();

            var data = $(this).serialize();
            var url = $(this).attr('data-url');
            var pageUrl = $(this).attr('data-url');
            var dataJson = JSON.stringify(data);
            
            console.log(data);

            $.ajax({
                method: 'get',
                url: '/press/ajaxQuery',
                data: data,
                success: function( data, pag ) {
                    $('#pressPosts').html(data);
                },
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
        });
        $('#articleSearch select').on('change' , function() {
            console.log('select made');
            $('#articleSearch').submit();
        });

        $(document).on("click", '.pagination a', function(e) { 
            e.preventDefault(); 
            var $url = $(this).attr('href');
            var $parts = $url.split('/');
            var $channel = $parts[3];
            var $last_part = $parts[$parts.length-1];
        
            // Grab the last URL variable to know where we are in terms or pagination
            // If empty, send through empty variable
            if($last_part == 'ajaxQuery') {
                var $last_part = '';
            }

            $.ajax({
                method: 'get',
                url: '/' + $channel +'/ajaxQuery/'+ $last_part,
                success: function(html) {
                    $('#pressPosts').html(html);
                },
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            });
        });
        // Pagination
        
    });
};
